module.exports = __webpack_public_path__ + "img/nfykdxfssd.55023855.png";